<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
        <template #layoutContent>
            <Card :title="$t('user.payslips')">
              <template #cardBody>
                <Payslips/>
              </template>
            </Card>
            
        </template>
    </SubLayout>
</template>



<script setup>
import Card from '@/components/Card.vue';
import Payslips from '../Employee/Payslips.vue';
import SubLayout from '../Layouts/partials/SubLayout.vue';
 
const title = i18n.global.t('user.payslips')
const breadcrumbs = [
  {
    name: i18n.global.t('user.payslips'),
    path: '/'
  },
]

</script>
